import { render, staticRenderFns } from "./ShippingLeads.vue?vue&type=template&id=a7da851a&scoped=true&"
import script from "./ShippingLeads.vue?vue&type=script&lang=js&"
export * from "./ShippingLeads.vue?vue&type=script&lang=js&"
import style0 from "./ShippingLeads.vue?vue&type=style&index=0&id=a7da851a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7da851a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7da851a')) {
      api.createRecord('a7da851a', component.options)
    } else {
      api.reload('a7da851a', component.options)
    }
    module.hot.accept("./ShippingLeads.vue?vue&type=template&id=a7da851a&scoped=true&", function () {
      api.rerender('a7da851a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/ShippingLeads.vue"
export default component.exports